import { useGetEquipmentFormOptionsQuery } from '@/common/infrastructure/gql/generated/schema';
import { EquipmentFormOptions } from '../types/EquipmentTypes';

export const useGetEquipmentFormOptions = (skip: boolean) => {
  const { data, loading, error } = useGetEquipmentFormOptionsQuery({
    skip,
    fetchPolicy: 'cache-and-network'
  });

  const formOptions = data?.supportingEquipmentData as EquipmentFormOptions | null | undefined;

  return {
    formOptions,
    loading,
    error,

    availableMakes: formOptions?.availableMakes ?? [],
    availableModels: formOptions?.availableModels ?? [],
    availableClasses: formOptions?.availableClasses ?? [],
    availableTypes: formOptions?.availableTypes ?? [],
    availableSizes: formOptions?.availableSizes ?? [],
    availableEmployees: formOptions?.availableEmployees ?? [],
    availableDefaultEmployees: formOptions?.availableDefaultEmployees ?? [],
    availableJobRoles: formOptions?.availableJobRoles ?? [],
    availableStatuses: formOptions?.availableStatuses ?? [],
    availableDispatchLocations: formOptions?.availableDispatchLocations ?? [],
    availableLocations: formOptions?.availableLocations ?? [],
    availableOutOfServiceReasons: formOptions?.availableOutOfServiceReasons ?? []
  };
};
